export const defaultIconSize = 48;
export const toolbarSize = 64;
export const toolbarTextColor = '#fff';
export const toolbarBackgroundColor = '#303030';
export const toolbarBackgroundLightColor = '#404040';
export const drawingToolbarHeight = 64;
export const drawingToolbarBackgroundColor = '#404040';
export const tabbarHeight = 48;
export const tabIndicatorColor = '#fff';
export const tabInactiveTextColor = '#888';
export const pageSliderContainerHeight = drawingToolbarHeight;
export const pageSliderBackgroundColor = '#fff';
export const markerMenuHeight = drawingToolbarHeight;
export const markerMenuBackgroundColor = toolbarBackgroundLightColor;
export const markerMenuTextColor = toolbarTextColor;
